import { Card, Form, Button, Input, InputNumber, Space, Divider } from 'antd';
import React from 'react';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

const validateMessages = {
  required: '${label} is required!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

function Forms() {

  const onFinish = (values: any) => {
    console.log(values);
  };

  return (
    <Card title="Form (v5)" bodyStyle={{ textAlign: 'left' }}>
      <Space>
        <div>Note: most of the current forms in EI are based on antv4/v3 legacy</div>
        <Divider />
      </Space>

      <Form
        {...layout}
        name="test-form"
        onFinish={onFinish}
        style={{ maxWidth: 600 }}
        validateMessages={validateMessages}
      >
        <Form.Item name={['user', 'name']} label="Name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item name={['user', 'email']} label="Email" rules={[{ type: 'email' }]}>
          <Input />
        </Form.Item>
        <Form.Item name={['user', 'config']} label="Config">
          <Input.TextArea />
        </Form.Item>
        <Form.Item name={['user', 'age']} label="Count" rules={[{ type: 'number', min: 0, max: 99 }]}>
          <InputNumber />
        </Form.Item>
        <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 8 }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Card>
  )
}


export default Forms;
